
let loggingEnabled:boolean;

const configureLogging=(loggingSettings:any)=>{
    loggingEnabled = loggingSettings?.logging?.enabled;
}

const getLoggingSettings=()=>{
    return{
        loggingEnabled
    }
}

export {configureLogging,getLoggingSettings};